import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { TabsUIStore, TABS_UI_INITIAL_STATE, type TabViewMode } from './tabsUI/tabsUI.types';
import { createTabsUIActions } from './tabsUI/tabsUI.actions';

export const TABS_VIEW_MODE_KEY = 'tabs-view-mode';

function getInitialViewMode(): TabViewMode {
  if (typeof window === 'undefined') return 'list';
  const saved = localStorage.getItem(TABS_VIEW_MODE_KEY);
  return saved === 'list' || saved === 'tables' ? saved : 'list';
}

export const useTabsUIStore = create<TabsUIStore>()(
  devtools(
    (set, get) => ({
      ...TABS_UI_INITIAL_STATE,
      viewMode: getInitialViewMode(),
      ...createTabsUIActions(set, get),
    }),
    {
      name: 'tabs-ui-store',
    }
  )
);
